import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationCloseCashViewPage } from '../../../configuration/configuration-close-cash/configuration-close-cash-view/configuration-close-cash-view';
import { AnalyticsPage } from '../../../analytics/analytics';
/**
 * Generated class for the HomeDashboardMinutePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-home-dashboard-minute',
  templateUrl: 'home-dashboard-minute.html',
})
export class HomeDashboardMinutePage {

  sales_day: any = 0;
  sales_tips: any = 0;
  total_tips: any = 0;
  total_elements_sold: any = 0;
  date = moment().format("YYYY-MM-DD");
  data_sales_day: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public http: HttpClient,
    public translate: TranslateService) {
    this.salesDay();
  }


  async salesDay() {
    //
    var date_first = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
    var date_last = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
    //
    const body = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('datetime_init', date_first)
      .set('datetime_final', date_last);

    await this.http.post(this.globals.analytics_path + 'sales-day', body).subscribe(async data => {
      this.sales_day = data['total_amount'];
      this.total_tips = data['total_tips'];
      this.sales_tips = parseFloat(this.sales_day) + parseFloat(this.total_tips)
      this.total_elements_sold = data['total_elements'];
      this.data_sales_day = true;
    },
      err => {
      }
    );
  }

  openAnalytics() {
    this.globals.side_menu_active = 'informes';
    this.navCtrl.push(AnalyticsPage);

  }

  closeCash() {
    this.globals.side_menu_active = 'sales';
    this.navCtrl.push(ConfigurationCloseCashViewPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-dashboard-minute/home-dashboard-minute.ts